import { autoinject, observable, bindable, computedFrom } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DialogService } from 'aurelia-dialog';
import { ConfirmDialog } from '_controls/confirm-dialog';
import { HttpClient } from 'aurelia-http-client';
import * as Dto from '_models/dtos';
import { SessionData } from '_models/session-data';
import { UrlService } from '_services/url-service';
import { SizeUtility } from '_controls/size-utility';
import { SortService } from '_services/sort-service';

@autoinject
export class ReviewSelections {
    private _http: HttpClient;
    private _url: UrlService;

    constructor(
        public router: Router,
        public sd: SessionData,
        public dialogSvc: DialogService
    ) {
        this._http = new HttpClient();
        this._url = new UrlService();
    }
    
    selections: Dto.WizardProductColorSelection[] = [];

    attached() {
        
        this.loadSelectionsFromSession();
    }

    loadSelectionsFromSession() {
        this.selections = this.sd.wizard.selectedColors.map(c =>
            new Dto.WizardProductColorSelection(this.sd.wizard.selectedProductUse, this.sd.wizard.selectedSubstrate, this.sd.wizard.selectedProduct, c));
    }
    
    selectionSort = new SortService('colorNumber', 'asc');

    sortSelections(propertyName: string) {
        this.selectionSort.sort(this.selections, propertyName);
    }

    removeSelection(sel: Dto.WizardProductColorSelection) {
        // Confirm if the user really wants to change products....
        this.dialogSvc.open({
            viewModel: ConfirmDialog,
            model: `Are you sure you want to remove the selection '${sel.color.colorNumber} - ${sel.color.colorName}'?`
        }).whenClosed(e => {

            if (!e.wasCancelled) {

                // Remove from selected colors list
                var idx = this.sd.wizard.selectedColors.findIndex(c => c.colorUID == sel.color.colorUID);
                if (idx > -1) {
                    this.sd.wizard.selectedColors.splice(idx, 1);
                }

                // Refresh selection list
                this.loadSelectionsFromSession();

                // Re-apply last sort
                this.selectionSort.sort(this.selections, this.selectionSort.sortProperty, this.selectionSort.sortDirection);
            }
        });
    }

    back() {
        this.sd.wizard.prev();
        this.sd.save();
    }

    addToProject() {
        this.sd.addWizardSelections();
        this.sd.save();
        this.continueToProjectSchedule();
    }

    continueToProjectSchedule() {
        var url = this._url.build('~/project-schedule');
        this.router.navigate(url);
    }
}
